import React, { useEffect, useRef, useState } from "react";
import FilterListIcon from "@mui/icons-material/FilterList";
import ViewcCasetable from "../../../../library/custom/gridTable/GridTable";
import SearchIcon from "@mui/icons-material/Search";
import SettingTable from "../../../incidents/incidentList/SettingTable";
import { useNavigate } from "react-router-dom";
import UserFilterList from "../../shared/UserFilterList ";
import { TableLoader } from "../../../../library/common/Loader";
import { PAGE_SIZE, ROW_PER_PAGE_SIZE } from "../../../../constant/constant";
import {
  ADMIN_CONTRACTOR,
  ADMIN_CONTRACTOR_DETAILS,
  ADMIN_SAFETY_LOG,
} from "../../../../constant/routeContant";
import DialogBox from "../../../../library/common/DialogBox";
import NORow from "../../../../library/custom/noRow/noRow";
import ReportRowManipulte from "../../../incidents/incidentList/ReportRowManipulte";
import { checkPrivileges } from "../../../../utils/rolesHelper";
import downloadIcon from "../../../../assets/downloadIcon.svg";
import { InactiveClient } from "../../../../utils/helper";
import check_Icon from "../../..../../../../assets/check_Icon.svg";
import cross_Icon from "../../..../../../../assets/cross_Icon.svg";
import verifyEmailCheckBox from "../../..../../../../assets/verifyEmailCheckBox.svg";
import { Grid } from "@mui/material";
import { useDebounce } from "../../../../utils/useDebounceSearch";

function ContractorTable({
  contractorGrades,
  deleteList,
  loading,
  getContractorListData,
  contractorListData,
  loadingContractor,
  filterShow = true,
  contractorTypes,
  isShowDowdownloadButton = true,
  setClickVerifyBtn,
  sendBulkEmailVarifation,
  setAccessUserId,
  accessUserId,
  ContractorListDatas,
  shouldRestoreState,
  division,
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [searchlocation, setSearchlocation] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const navigate = useNavigate();
  const [company, setCompany] = useState("");
  const [type, setType] = useState("");
  const [isTableLoading, setisTableLoading] = useState(false);
  //const [accessUserId, setAccessUserId] = useState([]);
  const [divisionfilter, setDivisionFilter] = useState("");

  const fetchContractors = ({
    page,
    pageSize: ps = pageSize,
    search: s = search,
    gradeId: g = company,
    type: t = type,
    isSendMail = false,
    divisionId: d = divisionfilter,
  } = {}) => {
    getContractorListData({
      page,
      pageSize: ps,
      search: s,
      gradeId: g,
      type: t,
      isSendMail,
      divisionId: d ? d : 0,
    });
  };

  const deletehandle = () => {
    if (InactiveClient()) return;
    setOpenModal(false);
    deleteList(selectedRow.id);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    window.close();
  };
  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handleautoSearch = (event) => {
    let searchText = "";
    if (event.target.value) {
      searchText = event.target.value;
    }
    setSearch(searchText);

    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setPage(0);
  };

  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    setPage(0);

    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    fetchContractors({
      page: 1,
      pageSize: newPazeSize,
    });
  };

  const handlePagignation = (newPage) => {
    setPage(newPage);

    fetchContractors({
      page: newPage + 1,
    });
  };

  const handleViewOnClick = (rows) => {
    sessionStorage.setItem("contractorListPreserveState", "true");
    navigate(ADMIN_CONTRACTOR_DETAILS, {
      state: { rowsss: rows.row, editMode: false },
    });
  };

  const handleOnclick = (rows) => {
    if (InactiveClient()) return;
    sessionStorage.setItem("contractorListPreserveState", "true");
    navigate(ADMIN_CONTRACTOR, {
      state: {
        contractorId: rows.row.id,
        userId: rows.row.userId,
        editMode: true,
      },
    });
  };
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const deleteIncidents = (rows) => {
    if (InactiveClient()) return;
    setOpenModal(true);
    setSelectedRow(rows);
  };

  const safetyLogOnClick = (rows) => {
    navigate(ADMIN_SAFETY_LOG, {
      state: { userId: rows.row, userSafetyLog: true },
    });
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 0.8 },
    {
      field: "contractorName",
      headerName: "Subcontractor Name",
      flex: 1.6,
    },
    // { field: "pocFirstName", headerName: "First Name", flex: 1.5 },
    // { field: "pocLastName", headerName: "Last Name", flex: 1.5 },
    {
      field: "pointOfContactName",
      headerName: "Point of Contact Name",
      type: "text",
      flex: 1.8,
      minWidth: 90,
      // renderCell: (cellValues) => {
      //   return (
      //     <>
      //       {cellValues?.row?.pocFirstName + " " + cellValues?.row?.pocLastName}
      //     </>
      //   );
      // },
    },
    {
      field: "email",
      headerName: "Email ID",
      flex: 3.3,
      renderCell: (rows) => {
        const email = rows?.row?.email || "";

        return (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "5px",
              width: "100%",
            }}
          >
            <div
              title={email}
              style={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                flex: 1,
                minWidth: "0",
                textAlign: "left",
              }}
            >
              {email}
            </div>
          </div>
        );
      },
    },
    {
      field: "isEmailVerified",
      headerName: "Verified Email",
      flex: 1.5,
      renderCell: (rows) => {
        return rows?.row?.isEmailVerified ? (
          <img src={check_Icon} alt="Verified" width="16" height="16" />
        ) : (
          <img src={cross_Icon} alt="Not Verified" width="18" height="18" />
        );
      },
    },
    { field: "contractorType", headerName: "Type", flex: 1 },
    { field: "grade", headerName: "Grade", flex: 0.8 },

    {
      field: "",
      width: 68,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return filterShow ? (
          <ReportRowManipulte
            rows={rows}
            viewOnClick={() => handleViewOnClick(rows)}
            editOnClick={() => handleOnclick(rows)}
            viewLabel="View Details"
            deleteOnClick={() => deleteIncidents(rows?.row)}
            edit={checkPrivileges([12, 43, 44])}
            editLabel="Edit Subcontractor"
            download={false}
            view={checkPrivileges([12, 43, 44, 45])}
            deleted={checkPrivileges([12, 43])}
            deleteLabel="Delete Subcontractor"
            safetyLogLabel="Safety Log"
            safetyLogOnClick={() => safetyLogOnClick(rows)}
            safetyLog={checkPrivileges([12, 43, 44, 45])}
          />
        ) : (
          ""
        );
      },
    },
  ];

  const companyOnChanges = (e) => {
    setCompany(e.target.value);
  };

  const handleApply = () => {
    setAnchorEl(null);
    setPage(0);
    window.close();

    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);

    fetchContractors({
      page: 1, // API page
      search,
      gradeId: company,
      type,
    });
  };
  const handleClear = () => {
    setCompany("");
    setType("");
    setAnchorEl(null);
    window.close();
    setSearch("");
    setPage(0);
    setPageSize(PAGE_SIZE);

    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setDivisionFilter("");
    fetchContractors({
      page: 1,
      pageSize: PAGE_SIZE,
      search: "",
      gradeId: "",
      type: "",
      divisionId: 0,
    });
  };

  const onRowClick = (rows) => {
    if (rows.value) {
      navigate(ADMIN_CONTRACTOR_DETAILS, {
        state: { rowsss: rows.row, editMode: false },
      });
    }
  };

  const sendEmail = () => {
    fetchContractors({
      page: page + 1,
      isSendMail: true,
    });
  };

  const sendBulkEmailVerify = () => {
    if (accessUserId?.length > 0) {
      setClickVerifyBtn(true);
      const data = {
        ids: accessUserId,
        type: 1,
      };
      sendBulkEmailVarifation(data);
    }
  };

  useEffect(() => {
    if (shouldRestoreState && ContractorListDatas?.filterObj) {
      const f = ContractorListDatas.filterObj;
      setSearch(f.search || "");
      setCompany(f.gradeId || "");
      setType(f.type || "");
      setPage((f.page || 1) - 1);
      setPageSize(f.pageSize || PAGE_SIZE);
      setDivisionFilter(f.divisionId === 0 ? "" : f.divisionId || "");
    } else if (shouldRestoreState === false) {
      setSearch("");
      setCompany("");
      setType("");
      setPage(0);
      setPageSize(PAGE_SIZE);
      setDivisionFilter("");
    }
  }, [shouldRestoreState]);

  const divisionFilterOnChanges = (e) => {
    setDivisionFilter(e?.target?.value);
  };
  const isFirstRender = useRef(true);
  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setPage(0);
    fetchContractors({
      page: 1,
      pageSize: pageSize,
      search: debouncedSearch ? debouncedSearch : "",
      gradeId: company,
      type: type,
    });
  }, [debouncedSearch]);

  return (
    <>
      <section className="grid_main_sec">
        <div className="grid_main_header two_grid">
          {openModal && (
            <DialogBox
              open={openModal}
              rows={[]}
              deletehandle={deletehandle}
              handleCloseModal={() => setOpenModal(false)}
              view
              content={"Are you sure you want to delete this Contractor?"}
            />
          )}
        </div>
        <div className={accessUserId?.length > 0 ? "userMain" : ""}>
          {" "}
          <div className="grid_main_body">
            <Grid
              container
              className="fixedDesign div-filter-container gapNone"
            >
              <Grid item sm={6} md={6} xs={12}>
                <div className="filter_of_caselist">
                  <div className="searchcaseid">
                    <label htmlFor="search">
                      <span>
                        <SearchIcon />
                      </span>
                      <div>
                        <input
                          id="search"
                          placeholder="Search"
                          type="text"
                          value={search}
                          className=""
                          onChange={handleautoSearch}
                          autoComplete="off"
                        />
                      </div>
                    </label>
                  </div>
                  {filterShow && (
                    <div className="filter_btn">
                      <button
                        aria-describedby={id}
                        variant="contained"
                        type="button"
                        name="btn"
                        onClick={(e) => handleClick(e)}
                      >
                        <FilterListIcon id="icn" /> Filters
                      </button>
                      {/* <FilterButton
                label={"Filters"}
                handleClick={(e) => handleClick(e)}
              /> */}
                      <UserFilterList
                        firstLabel="Grade"
                        id={id}
                        open={open}
                        anchorEl={anchorEl}
                        handleClose={handleClose}
                        searchlocation={searchlocation}
                        setSearchlocation={setSearchlocation}
                        handleApply={handleApply}
                        firstLebelFilter={contractorGrades}
                        firstLebelOnChanges={companyOnChanges}
                        firstLebelValue={company}
                        secondLebelFilter={contractorTypes}
                        secondLebelOnChanges={(e) => setType(e.target.value)}
                        secondLabel={"Type"}
                        secondLebelValue={type}
                        handleClear={handleClear}
                        resetBtn={true}
                        isShow={true}
                        thirdLebelFilter={division}
                        thirdLabel="Division"
                        thirdLebelOnChanges={divisionFilterOnChanges}
                        thirdLebelValue={divisionfilter}
                      />
                    </div>
                  )}
                </div>
              </Grid>
              <Grid item sm={6} md={6} xs={12}>
                <Grid container spacing={2}>
                  <Grid item md={7} xs={12} className="emailRight">
                    {accessUserId?.length > 0 && (
                      <div
                        className={`div-verify-email-right ${
                          accessUserId?.length === 0 ? "asscssuser" : ""
                        }`}
                        onClick={sendBulkEmailVerify}
                      >
                        <span>
                          <img
                            src={verifyEmailCheckBox}
                            className="DownLoadLogo"
                            alt="DownLoad Logo"
                          />
                        </span>
                        Verify Selected Emails
                      </div>
                    )}
                  </Grid>
                  <Grid item md={5} xs={12}>
                    {isShowDowdownloadButton && (
                      <div
                        className="div-download-email-right"
                        onClick={sendEmail}
                      >
                        <span>
                          <img
                            src={downloadIcon}
                            className="DownLoadLogo"
                            alt="DownLoad Logo"
                          />
                        </span>
                        Download Data
                      </div>
                    )}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            {isTableLoading ? (
              ""
            ) : (
              <div className="desc_box row_uniq">
                <div className="table_style_ui">
                  <ViewcCasetable
                    getRowId={(r) => r?.userId}
                    rows={contractorListData?.result?.contractorData || []}
                    rowCount={contractorListData?.result?.noOfRecords || 0}
                    columns={columns}
                    // onClick={(rows) => onRowClick(rows)}
                    loading={loading || loadingContractor}
                    components={{
                      LoadingOverlay: TableLoader,
                      NoRowsOverlay: NORow,
                    }}
                    checkboxSelection={true}
                    page={page}
                    pagination
                    pageSize={pageSize}
                    rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                    onPageSizeChange={handlePageSizeChange}
                    onPageChange={handlePagignation}
                    backIconButtonProps={{ disabled: false }}
                    disableSelectionOnClick
                    isRowSelectable={(params) =>
                      params?.row?.isEmailVerified === false
                    }
                    onSelectionModelChange={setAccessUserId}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
}

export default ContractorTable;
